import React from 'react';
import { Caste, User } from '../../App';
import { ContextMenu, ContextMenuItem } from '../ContextMenu';
import Endpoints from '../../endpoints';


interface UserContextMenuProps {
    user: User;
    invoker: User | null;
    onBanStateChange: (userId: string, banState: boolean) => void;
    onAdminStateChange: (userId: string, caste: Caste) => void;
}

export const UserContextMenu: React.FC<UserContextMenuProps> = (props) => {

    const makeAdmin = () => {
        const [ep, method] = Endpoints.USER_MAKE_ADMIN(props.user.id);
        fetch(ep, {
            method
        }).then((res) => {
            if (!res.ok) {
                throw new Error(res.statusText);
            }
            props.onAdminStateChange(props.user.id, Caste.Admin);

        })
            .catch((err) => console.log(err));
    };

    const setBanUser = (banState: boolean) => {
        const [ep, method] = Endpoints.USER_SET_BAN(props.user.id, banState);
        fetch(ep, {
            method
        }).then((res) => {
            if (!res.ok) {
                throw new Error(res.statusText);
            }

            props.onBanStateChange(props.user.id, banState);
        })
            .catch((err) => console.log(err));
    }

    const items: Array<ContextMenuItem<User>> = [];

    if (props.invoker !== null && props.invoker.caste === Caste.Admin) {
        if (props.user.caste !== Caste.Admin) {
            items.push(
                {
                    action: () => makeAdmin(),
                    title: 'Make Admin',
                }
            );
            if (props.user.isBanned) {
                items.push({
                    action: () => setBanUser(false),
                    title: 'Unban'
                });
            } else {
                items.push({
                    action: () => setBanUser(true),
                    title: 'Ban'
                });
            }
        }
    }

    return (
        <ContextMenu<User>
            ctx={props.user}
            items={items}
        >
            {props.children}
        </ContextMenu>
    );
};
